import {AxiosPromise} from 'axios';
import api from './api';
import apiGraphQL from './apiGraphQL';
import {LocationType, SessionTypes} from '../enums';
import {DefaultSuccessResponse} from '../interfaces';

export function getTeamSessions(teamId?: number) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api
        .get(`/teamsessions${teamId ? `?teamId=${teamId}` : ''}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function getTeamSessionDetail(id: number) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api
        .get(`/teamsessions/${id}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function updateTeamSession(
  id: number,
  params: {
    timeZone?: string;
  },
) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api
        .put(`/teamsessions/${id}`, params)
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function updateSessionMetaData(input: {
  teamSessionId?: number;
  playerSessionId?: number;
  locationType?: LocationType | null;
  teamScore?: number | null;
  opponentName?: string | null;
  opponentScore?: number | null;
}) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      apiGraphQL
        .post('/graphql', {
          query: `mutation UpdateSessionDetail($input: UpdateSessionDetailInput!) {
            updateSessionDetail(input: $input) {
              id
            }
          }`,
          variables: {
            input,
          },
        })
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function updateTeamSessionWithXml(input: {
  teamSessionId: number;
  xmlFileData?: string;
  fileName?: string;
}) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      apiGraphQL
        .post('/graphql', {
          query: `mutation UpdateTeamSession($input: UpdateTeamSessionInput!) {
            updateTeamSession(input: $input) {
              error
              success
            }
          }`,
          variables: {
            input,
          },
        })
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function adminDeleteTeamSession(teamSessionId: number) {
  return new Promise<DefaultSuccessResponse>((resolve, reject) => {
    try {
      apiGraphQL
        .post('/graphql', {
          query: `mutation AdminDeleteTeamSession($input: AdminDeleteTeamSessionInput!) {
            adminDeleteTeamSession(input: $input) {
              success
              error
            }
          }`,
          variables: {
            input: {
              teamSessionId,
            },
          },
        })
        .then(response => {
          resolve(response?.data?.data?.adminDeleteTeamSession ?? null);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function adminChangeTeamSessionType(
  teamSessionId: number,
  type: SessionTypes,
) {
  return new Promise<DefaultSuccessResponse>((resolve, reject) => {
    try {
      apiGraphQL
        .post('/graphql', {
          query: `mutation AdminChangeTeamSessionType($input: AdminChangeTeamSessionTypeInput!) {
            adminChangeTeamSessionType(input: $input) {
              success
              error
            }
          }`,
          variables: {
            input: {
              teamSessionId,
              type,
            },
          },
        })
        .then(response => {
          resolve(response?.data?.data?.adminChangeTeamSessionType ?? null);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}
